import { AbstractBaseInputView } from './AbstractBaseInputView';
import { isDate, isUndefined } from '@fxts/core';
import { DateInputCalendarController } from '../../DateInputField/DateInputCalendarController';
import { BaseInputProps, DateInputAttribute } from '../types';
import { format as formatDate } from 'date-fns';

/**
 * @see {BaseInputFactory}
 * @example
 * ```ts
 * BaseInputFactory.create('date');
 * BaseInputFactory.create('date', new Date());
 * ```
 */
export class DateInputView extends AbstractBaseInputView<Date> {
  protected override attribute: DateInputAttribute;
  private readonly calendarController: DateInputCalendarController;

  public static readonly defaultFormat = 'yyyy-MM-dd';

  constructor(value?: Date, attribute?: Omit<DateInputAttribute, 'readonly'>, props?: BaseInputProps) {
    super('text', value, attribute, props);
    this.attribute = {
      ...attribute,
      readonly: true,
    };
    this.calendarController = new DateInputCalendarController(this, {
      locale: this.attribute.locale ?? 'kr',
    });
  }

  protected parseValue(value: string | undefined): Date | undefined {
    try {
      if (isUndefined(value)) {
        return undefined;
      }
      const parsed = new Date(value);
      return isDate(parsed) ? parsed : undefined;
    } catch (_e) {
      return undefined;
    }
  }

  protected override formatValue(value: Date | undefined): string {
    const { format = DateInputView.defaultFormat } = this.attribute;
    return isUndefined(value) ? '' : formatDate(value, format);
  }

  override onRender() {
    this.calendarController.init();
  }
}
